import { useNostr } from "@nostrify/react";
import { useQuery } from "@tanstack/react-query";
import type { NostrMetadata } from "@nostrify/nostrify";

/**
 * Fetch a single kind-0 profile for a pubkey. Returns parsed metadata.
 * Ported (simplified) from treasures.to.
 */
export function useAuthor(pubkey: string | undefined) {
  const { nostr } = useNostr();

  return useQuery({
    queryKey: ["author", pubkey ?? ""],
    enabled: !!pubkey,
    staleTime: 5 * 60 * 1000,
    queryFn: async (c) => {
      const signal = AbortSignal.any([
        c.signal,
        AbortSignal.timeout(5000),
      ]);
      const [event] = await nostr.query(
        [{ kinds: [0], authors: [pubkey!], limit: 1 }],
        { signal },
      );
      if (!event) return { metadata: undefined as NostrMetadata | undefined };
      try {
        return { metadata: JSON.parse(event.content) as NostrMetadata };
      } catch {
        return { metadata: undefined as NostrMetadata | undefined };
      }
    },
  });
}
